import { createContext, useContext, useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export const homeFor = (role) => (role === "owner" ? "/owner" : role === "contractor" ? "/contractor" : "/dashboard");

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  useEffect(() => {
    if (!localStorage.getItem("nf_token")) { setUser(false); return; }
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => { localStorage.removeItem("nf_token"); setUser(false); });
  }, []);
  const signIn = (data) => { localStorage.setItem("nf_token", data.token); setUser(data.user); };
  const logout = () => { localStorage.removeItem("nf_token"); setUser(false); };
  return <AuthCtx.Provider value={{ user, signIn, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const Spinner = () => (
  <div className="flex justify-center py-24" data-testid="loading-spinner"><Loader2 className="h-6 w-6 animate-spin text-teal-600" /></div>
);

export function Protected({ roles, children }) {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Spinner />;
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(loc.pathname)}`} replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to={homeFor(user.role)} replace />;
  return children;
}
